<!-- Accordion to <details> conversion
 Convert custom accordion component to native `<details>` element to improve accessibility -->
<details class="accordion-item" [open]="accordion.isOpen">
  <summary class="accordion-header" (click)="toggleAccordion(accordion, $event)">
    <span>
      {{ accordion.title }}
    </span>
    <span class="accordion-header-right">
      @if(accordion.additionalText){
      {{ accordion.additionalText }}
      }
      <div class="toggle-button">
        <i class="fa" [ngClass]="{'fa-chevron-up': accordion.isOpen, 'fa-chevron-down': !accordion.isOpen}"></i>
      </div>
    </span>
  </summary>
  <div class="accordion-body">
    <ng-content></ng-content>
  </div>
</details>